import { CircularProgress } from "@heroui/react"

const LoadingIndicator = ({
  label
}: { label?: string; }) => {

  return (
    <div className="h-screen flex justify-center item-center">
      <CircularProgress color="success" label={label} />
    </div>
  )
}

export default LoadingIndicator;